import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import FloodAnalysis_001 from './img/FloodAnalysis_001.png'
import FloodAnalysis_002 from './img/FloodAnalysis_002.png'


export default class FloodAnalysis extends Component {
  render() {
    return (
      <div className="main-window">
      <div className="main-window-title">使用水淹分析功能</div>
      <div className="main-window-content">使用水淹分析功能，需先在图层管理中开启高程地图:</div>
      <div className="main-window-content">1、开启高程地图</div>
      <div className="main-window-content">2、点击水淹分析按钮</div>
      <div className="main-window-content">3、选取所需分析的具体区域，鼠标点击形成区域，双击结束选取</div>
      <div className="main-window-content">4、选择最低、最高水位</div>
      <div className="main-window-content">5、点击播放，展示水淹</div>
      <div className="main-window-content">6、点击清除，结束水淹分析</div>
      <img src={FloodAnalysis_001} className="main-window-img"></img>
      <img src={FloodAnalysis_002} className="main-window-img"></img>
    </div>
    )
  }
}
